import countries from 'i18n-iso-countries';
import '@formatjs/intl-locale/polyfill';
import '@formatjs/intl-displaynames/polyfill';
import '@formatjs/intl-displaynames/locale-data/en';
import '@formatjs/intl-displaynames/locale-data/fr';
import '@formatjs/intl-displaynames/locale-data/es';
import '@formatjs/intl-displaynames/locale-data/ca';
import '@formatjs/intl-displaynames/locale-data/it';
import '@formatjs/intl-displaynames/locale-data/br';
import '@formatjs/intl-displaynames/locale-data/nl';
import '@formatjs/intl-displaynames/locale-data/de';
import '@formatjs/intl-displaynames/locale-data/ru';
import '@formatjs/intl-displaynames/locale-data/eu';
import '@formatjs/intl-displaynames/locale-data/pt';
import '@formatjs/intl-displaynames/locale-data/el';
import '@formatjs/intl-displaynames/locale-data/tr';

export function capitalizeFirstLetter(string) {
    if (!string || string.length === 0) {
        return '';
    }

    return `${string.charAt(0).toUpperCase()}${string.slice(1).toLowerCase()}`;
}

export function translateLocale(locale, localeToTranslate) {
    if (!localeToTranslate) return '-';
    let tmpLocaletoTranslate = localeToTranslate.replace('_', '-');
    let languageNames = new Intl.DisplayNames([locale], { type: 'language' });

    return languageNames.of(tmpLocaletoTranslate);
}

export function translateCountry(locale, country) {
    const localeSplitted = locale.replace('_', '-').split('-');
    const lang = localeSplitted[0];
    return countries.getName(country, lang, { select: 'official' });
}
